var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26562 9.75C4.81385 9.75 2.01562 12.5482 2.01562 16V17C2.01562 17.4142 1.67984 17.75 1.26562 17.75C0.851411 17.75 0.515625 17.4142 0.515625 17V16C0.515625 11.7198 3.98542 8.25 8.26562 8.25C12.5458 8.25 16.0156 11.7198 16.0156 16V17C16.0156 17.4142 15.6798 17.75 15.2656 17.75C14.8514 17.75 14.5156 17.4142 14.5156 17V16C14.5156 12.5482 11.7174 9.75 8.26562 9.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.26562 1.75C6.4707 1.75 5.01562 3.20507 5.01562 5C5.01562 6.79493 6.4707 8.25 8.26562 8.25C10.0606 8.25 11.5156 6.79493 11.5156 5C11.5156 3.20507 10.0606 1.75 8.26562 1.75ZM3.51562 5C3.51562 2.37665 5.64227 0.25 8.26562 0.25C10.889 0.25 13.0156 2.37665 13.0156 5C13.0156 7.62335 10.889 9.75 8.26562 9.75C5.64227 9.75 3.51562 7.62335 3.51562 5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUser);
export default __webpack_public_path__ + "static/media/icon-user.50f6b1e9492d5e63cba41e12f16ca691.svg";
export { ForwardRef as ReactComponent };